import { Footer } from "@layouts/Footer";
import heroImage from "@assets/images/Group-1410087795.svg";
import mailIcon from "@assets/images/mail-fill.svg";
import phoneIcon from "@assets/images/phone-fill.svg";
import buildingIcon from "@assets/images/building-2-fill.svg";
import {
  HeroSection,
  PaymentStepsSection,
  BillInfoSection,
  RefundsSection,
  EmergencyCTASection,
} from "../../components";

/**
 * Residential Services / Pay Bill Page
 *
 * Online services page for residential customers.
 * Covers bill payment, meter reading, and account management.
 */
export function Services() {
  return (
    <div className="w-full flex flex-col items-start justify-center bg-white">
      <HeroSection
        title="Manage Your Gas Account Anywhere."
        description="Pay bills, check usage, submit meter readings, or update your account all from one secure and convenient online platform."
        heroImage={heroImage}
      />
      <PaymentStepsSection />
      <BillInfoSection />
      <RefundsSection />
      <EmergencyCTASection
        title="Need Help with your Bill or Account"
        subtitle={
          <>
            Call our 24/7 Emergency Line: 800-GASIS (42747)
            <br />
            or report a concern via our Online Safety Form.
          </>
        }
      >
        {/* Contact Card */}
        <div className="rounded-3xl bg-white flex flex-col items-start p-6 gap-4">
          <div className="flex items-center gap-2.5">
            <img src={mailIcon} alt="" className="w-4 h-4" />
            <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
              help@gasis.ae
            </span>
          </div>
          <div className="flex items-center gap-2.5">
            <img src={phoneIcon} alt="" className="w-4 h-4" />
            <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
              Support (8 AM – 8 PM)
            </span>
          </div>
          <div className="flex items-center gap-2.5">
            <img src={buildingIcon} alt="" className="w-4 h-4" />
            <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
              Sunday – Thursday (8 AM – 6 PM)
            </span>
          </div>
        </div>
      </EmergencyCTASection>
      <Footer />
    </div>
  );
}

export default Services;
